<template>
  <div class="text-center">
    <v-dialog
      v-model="$store.usersStore.state.editPermisosUserModal"
      max-width="760"
      scrollable
      persistent
    >
      <v-card
        :loading="$store.usersStore.state.loadingJobTypes || loading_user_projects"
        :disabled="$store.usersStore.state.loadingJobTypes || loading_user_projects"
        class="pm-card"
        elevation="0"
      >
        <!-- Header -->
        <div class="pm-header">
          <div class="d-flex align-center" style="gap: 12px;">
            <div class="pm-avatar">
              <v-icon color="white" size="20">mdi-account-circle-outline</v-icon>
            </div>
            <div>
              <p class="pm-title mb-0">
                Editar permisos: <strong>{{ $store.usersStore.state.selectedUserInfo.name }}</strong> - {{ selectedProject.name }}
              </p>
              <p class="pm-subtitle mb-0">Permisos por proyecto</p>
            </div>
          </div>
          <v-btn icon small @click="closeModal" class="pm-close-btn">
            <v-icon size="18" color="white">mdi-close</v-icon>
          </v-btn>
        </div>

        <v-card-text class="pa-0">
          <div class="pm-body">
            <p class="pm-hint">
              Los permisos se asignan por proyecto. Si bien los cargos tienen permisos preestablecidos, aquí puedes modificarlos de forma independiente.
            </p>

            <v-form ref="form" v-model="validform">
              <!-- Proyecto -->
              <p class="pm-field-label">Proyecto</p>
              <div class="d-flex align-center" style="gap: 10px;">
                <v-select
                  v-model="selected_project"
                  :items="user_projects"
                  :loading="loading_user_projects"
                  item-text="name"
                  item-value="id"
                  label="Seleccione proyecto"
                  outlined
                  dense
                  hide-details
                  class="pm-select"
                  @change="getCapabilities"
                />
                <v-btn fab x-small depressed color="#2D4B95" dark
                  @click="$store.projectsStore.commit('setNewProjectModal', true)">
                  <v-icon size="16">mdi-plus</v-icon>
                </v-btn>
              </div>

              <v-divider class="pm-divider" />

              <!-- Permisos header -->
              <div class="d-flex align-center justify-space-between flex-wrap pm-perms-header">
                <div>
                  <p class="pm-section-main-title mb-0">Permisos</p>
                  <p class="pm-hint mb-0">Selecciona un cargo para cargar permisos por defecto</p>
                </div>
                <div class="d-flex align-center" style="gap: 10px; flex-wrap: wrap;">
                  <!-- Seleccionar todo general -->
                  <div class="pm-select-all-global" @click="toggleAll">
                    <v-icon size="15" :color="allSelected ? '#2D4B95' : allIndeterminate ? '#2D4B95' : '#bbb'" class="mr-1">
                      {{ allSelected ? 'mdi-checkbox-marked' : allIndeterminate ? 'mdi-minus-box' : 'mdi-checkbox-blank-outline' }}
                    </v-icon>
                    <span :class="['pm-select-all-label', (allSelected || allIndeterminate) ? 'pm-select-all-label--active' : '']">
                      {{ allSelected ? 'Deseleccionar todo' : 'Seleccionar todo' }}
                    </span>
                  </div>
                  <v-select
                    :items="$store.usersStore.state.jobTypes"
                    :loading="$store.usersStore.state.loadingJobType"
                    item-text="name"
                    item-value="id"
                    label="Seleccione cargo"
                    outlined
                    dense
                    hide-details
                    return-object
                    style="max-width: 200px;"
                    @change="setJobTypeSelected"
                  />
                </div>
              </div>

              <!-- Grid de permisos -->
              <div class="pm-grid">

                <!-- General Proyecto -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-account-multiple-outline</v-icon>
                      General Proyecto
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('general')">
                      {{ sectionAllSelected('general') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.config_project_closing_system" label="Configurar Sistemas de Cierre" hide-details dense class="pm-check" />
                </div>

                <!-- Usuarios -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-account-multiple-outline</v-icon>
                      Usuarios
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('usuarios')">
                      {{ sectionAllSelected('usuarios') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.create_users" label="Crear usuarios" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.edit_users" label="Editar usuarios" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.view_users_interactions" label="Ver interacciones de usuarios" hide-details dense class="pm-check" />
                </div>

                <!-- RDI -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-file-document-multiple-outline</v-icon>
                      RDI
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('rdi')">
                      {{ sectionAllSelected('rdi') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.create_rdi" label="Crear RDI" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.view_rdi" label="Visualizar RDI" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.interact_rdi" label="Interactuar RDI" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.end_rdi" label="Finalizar RDI" hide-details dense class="pm-check" />
                </div>

                <!-- Consultas / Restricciones -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-clipboard-text-outline</v-icon>
                      Tareas / Restricciones
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('tareas')">
                      {{ sectionAllSelected('tareas') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.create_tasks" label="Crear tareas" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.assign_responsable_task" label="Asignar responsable" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.change_responsable_task" label="Cambiar responsable" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.change_priority_task" label="Cambiar prioridad" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.change_critical_date_task" label="Cambiar fecha crítica" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.view_tasks_listing" label="Ver listado de vigentes" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.view_personal_tasks" label="Ver tareas personales" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.interact_tasks" label="Interactuar tareas" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.interact_tasks_others" label="Interactuar tareas de otros" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.end_tasks" label="Finalizar tareas" hide-details dense class="pm-check" />
									<v-checkbox v-model="permisos.set_kanban_project_column" label="Crear Columnas Kanban" hide-details dense class="pm-check" />
									<v-checkbox v-model="permisos.full_change_kanban" label="Mover cualquier tarea (Kanban)" hide-details dense class="pm-check" />
                </div>

                <!-- Adicionales -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-notebook-plus-outline</v-icon>
                      Adicionales
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('adicionales')">
                      {{ sectionAllSelected('adicionales') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.create_additionals" label="Crear adicionales" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.view_additionals" label="Visualizar adicionales" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.change_status_additionals" label="Modificar estado (revisiones)" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.add_payment_status_additionals" label="Agregar estados de pago" hide-details dense class="pm-check" />
                </div>

                <!-- Planimetría -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-calendar-multiselect</v-icon>
                      Planimetría
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('planimetria')">
                      {{ sectionAllSelected('planimetria') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.add_forge_model" label="Agregar Planos / Modelos" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.assign_main_model" label="Asignar Modelo Principal" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.delete_forge_model" label="Eliminar Planos / Modelos" hide-details dense class="pm-check" />
                </div>

                <!-- Programación -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-calendar-multiselect</v-icon>
                      Programación
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('planning')">
                      {{ sectionAllSelected('planning') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.create_planning" label="Cargar programación inicial" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.update_planning_progress" label="Agregar avance (actualizaciones reales)" hide-details dense class="pm-check" />
                </div>

                <!-- Reuniones -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-account-group-outline</v-icon>
                      Reuniones/Minutas
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('meetings')">
                      {{ sectionAllSelected('meetings') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <v-checkbox v-model="permisos.view_project_meetings" label="Ver reuniones del proyecto" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.create_meetings" label="Crear reuniones" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.edit_meetings" label="Editar reuniones" hide-details dense class="pm-check" />
                  <v-checkbox v-model="permisos.delete_meetings" label="Eliminar reuniones" hide-details dense class="pm-check" />
                </div>

                <!-- Entregas -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-format-list-checks</v-icon>
                      Entregas
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('entregas')">
                      {{ sectionAllSelected('entregas') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <div class="pm-files-grid">
                    <v-checkbox v-model="permisos.view_entregas" label="Ver Entregas" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.create_entregas" label="Crear Entregas" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.delete_entregas" label="Eliminar Entregas" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.interact_entregas" label="Interactuar Entregas (Checks)" hide-details dense class="pm-check" />
										<v-checkbox v-model="permisos.edit_site_entregas" label="Editar Emplazamiento Entrega" hide-details dense class="pm-check" />
                  </div>
                </div>

                <!-- Sistema de archivos -->
                <div class="pm-section">
                  <div class="pm-section-header">
                    <p class="pm-section-title mb-0">
                      <v-icon size="13" color="#2D4B95" class="mr-1">mdi-folder-outline</v-icon>
                      Sistema de archivos
                    </p>
                    <span class="pm-select-all-section" @click="toggleSection('archivos')">
                      {{ sectionAllSelected('archivos') ? 'Ninguno' : 'Todos' }}
                    </span>
                  </div>
                  <div class="pm-files-grid">
                    <v-checkbox v-model="permisos.create_files" label="Crear archivos" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.create_folders" label="Crear carpetas" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.rename_files" label="Renombrar archivos" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.move_files" label="Mover archivos" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.delete_files" label="Eliminar archivos" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.delete_folders" label="Eliminar carpetas" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.restore_files" label="Restaurar archivos" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.restore_folders" label="Restaurar carpetas" hide-details dense class="pm-check" />
                    <v-checkbox v-model="permisos.send_to_autodesk" label="Enviar a visor Autodesk" hide-details dense class="pm-check" />
                  </div>
                </div>

              </div>
            </v-form>
          </div>
        </v-card-text>

        <!-- Footer -->
        <div class="pm-footer">
          <v-btn rounded outlined depressed class="pm-btn-cancel" @click="closeModal">
            Cancelar
          </v-btn>
          <v-btn rounded depressed dark color="#2D4B95" :loading="loadingData" :disabled="!canSave" @click="setCapabilities">
            Confirmar cambios
          </v-btn>
        </div>

      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { setCapabilitiesByUserProject, getCapabilitiesByUserProject } from '@/helpers/api/user'
import { getProjectsByUserID, getProjectsByUser } from '@/helpers/api/project'

const DEFAULT_PERMISOS = {
  config_project_closing_system: false,
	assign_main_model: false,
	add_forge_model: false,
	delete_forge_model: false,
  create_rdi: false,
  view_rdi: false,
  interact_rdi: false,
  end_rdi: false,
  create_additionals: false,
  view_additionals: false,
  change_status_additionals: false,
  add_payment_status_additionals: false,
  create_planning: false,
  update_planning_progress: false,
  create_tasks: false,
  assign_responsable_task: false,
  change_responsable_task: false,
  change_priority_task: false,
  change_critical_date_task: false,
  view_tasks_listing: false,
  view_personal_tasks: false,
  interact_tasks: false,
  interact_tasks_others: false,
  end_tasks: false,
	set_kanban_project_column: false,
	full_change_kanban: false,
  create_files: false,
  create_folders: false,
  rename_files: false,
  move_files: false,
  delete_files: false,
  delete_folders: false,
  send_to_autodesk: false,
	view_entregas: false,
	create_entregas: false,
	delete_entregas: false,
	interact_entregas: false,
	edit_site_entregas: false,
	restore_files: false,
	restore_folders: false,
  view_project_meetings: false,
  create_meetings: false,
  edit_meetings: false,
  delete_meetings: false,
	create_users: false,
	edit_users: false,
	view_users_interactions: false,
}

// Mapeo de secciones a sus claves de permisos
const SECTION_KEYS = {
  general:    ['config_project_closing_system'],
  usuarios:    ['create_users', 'edit_users', 'view_users_interactions'],
  rdi:         ['create_rdi', 'view_rdi', 'interact_rdi', 'end_rdi'],
  tareas:      ['create_tasks', 'assign_responsable_task', 'change_responsable_task', 'change_priority_task', 'change_critical_date_task', 'view_tasks_listing', 'view_personal_tasks', 'interact_tasks', 'interact_tasks_others', 'end_tasks', 'set_kanban_project_column', 'full_change_kanban'],
  adicionales: ['create_additionals', 'view_additionals', 'change_status_additionals', 'add_payment_status_additionals'],
  planning:    ['create_planning', 'update_planning_progress'],
  meetings:    ['view_project_meetings', 'create_meetings', 'edit_meetings', 'delete_meetings'],
  archivos:    ['create_files', 'create_folders', 'rename_files', 'move_files', 'delete_files', 'delete_folders', 'send_to_autodesk', 'restore_files', 'restore_folders'],
	entregas:    ['view_entregas', 'create_entregas', 'delete_entregas', 'interact_entregas', 'edit_site_entregas'],
	planimetria: ['add_forge_model', 'assign_main_model', 'delete_forge_model'],
}

const ALL_KEYS = Object.keys(DEFAULT_PERMISOS)

export default {
  name: 'EditPermisosUserModal',
  data: () => ({
    validform: true,
    user_projects: [],
    projects_id: [],
    selected_project: null,
    loading_user_projects: true,
    loading_project_list: false,
    loadingData: false,
    permisos: { ...DEFAULT_PERMISOS },
  }),
  computed: {
    allSelected () {
      return ALL_KEYS.every(k => this.permisos[k])
    },
    allIndeterminate () {
      return ALL_KEYS.some(k => this.permisos[k]) && !this.allSelected
    },
    selectedProject() {
      return this.$store.projectsStore.state.selectedProject
    },
		canSave() {
			return Boolean(this.selected_project && this.user_projects.some(project => project.id === this.selected_project))
		},
		userInfo(){
			return this.$store.userStore.state.userInfo
		},
  },
  mounted () {
    const projectID = this.$store.projectsStore.state.selectedProject.id
    this.$store.usersStore.dispatch('jobTypesGet', projectID)
    this.getUserProjects()
  },
  methods: {
    // ── Seleccionar todo general ──────────────────────
    toggleAll () {
      const value = !this.allSelected
      ALL_KEYS.forEach(k => { this.permisos[k] = value })
    },

    // ── Seleccionar todo por sección ──────────────────
    sectionAllSelected (section) {
      return SECTION_KEYS[section].every(k => this.permisos[k])
    },
    toggleSection (section) {
      const value = !this.sectionAllSelected(section)
      SECTION_KEYS[section].forEach(k => { this.permisos[k] = value })
    },

    // ── API ───────────────────────────────────────────
    async getProjectList () {
      if (!this.$store.projectsStore.state.projectsList) {
        this.loading_project_list = true
        const projects = await getProjectsByUser()
        if (projects.code === 200) {
          this.$store.projectsStore.commit('setProjectsList', projects.projects)
        }
        this.loading_project_list = false
      }
    },
    setJobTypeSelected (select) {
      if (select && select.default_capabilities) {
        this.permisos = { ...DEFAULT_PERMISOS, ...select.default_capabilities }
      }
    },
    async getUserProjects () {
      this.loading_user_projects = true
      const projects = await getProjectsByUserID({
        user_id: this.$store.usersStore.state.selectedUserInfo.id,
		permissions: true,
      })
      if (projects.code === 200) {
        this.user_projects = projects.projects
        this.selected_project = this.selectedProject.id
        this.projects_id = projects.projects.map(item => item.id)
        await this.getCapabilities()
      }
      this.loading_user_projects = false
    },
    async setCapabilities () {
      this.loadingData = true
      const data = {
        user_id: this.$store.usersStore.state.selectedUserInfo.id,
        project_id: this.selected_project,
        capabilities: this.permisos,
      }
      const capabilities = await setCapabilitiesByUserProject(data)
      if (capabilities.code === 200) {
				if(this.userInfo.id == this.$store.usersStore.state.selectedUserInfo.id){
					this.$store.projectsStore.dispatch('getSelectedProject')
				}
        this.$store.globalStore.dispatch('addMessage', {
          message: 'Se han actualizado los permisos del usuario para el proyecto seleccionado.',
          title: 'Usuario actualizado',
          created: new Date(),
          type: 'success',
          icon: 'mdi-check-circle',
          color: '#3EBFA3',
        })
				this.closeModal()
      }
      this.loadingData = false
    },
    getCapabilities () {
      return new Promise((resolve) => {
        const data = {
          user_id: this.$store.usersStore.state.selectedUserInfo.id,
          project_id: this.selected_project,
        }
        getCapabilitiesByUserProject(data)
          .then((capabilities) => {
            this.permisos = Object.assign({ ...DEFAULT_PERMISOS }, capabilities.user_project.capabilities)
            resolve(true)
          })
          .catch(() => resolve(false))
      })
    },
    closeModal () {
      this.$store.usersStore.commit('setSelectedUserInfo', null)
      this.$store.usersStore.commit('setEditPermisosUserModal', false)
      this.permisos = { ...DEFAULT_PERMISOS }
      this.validform = true
      this.loadingData = false
    },
  },
}
</script>

<style scoped>
.pm-card {
  border-radius: 12px !important;
  overflow: hidden;
}

/* Header */
.pm-header {
  background-color: #1C3A7A;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pm-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.pm-title { font-size: 14px; font-weight: 400; color: #ffffff; }
.pm-subtitle { font-size: 11px; color: rgba(255, 255, 255, 0.6); }
.pm-close-btn { background: rgba(255, 255, 255, 0.1) !important; }
.pm-close-btn:hover { background: rgba(220, 60, 60, 0.45) !important; }

/* Body */
.pm-body { padding: 20px 24px 8px; }
.pm-hint { font-size: 12px; color: #707070; line-height: 1.6; margin-bottom: 16px; }
.pm-field-label {
  font-size: 11px; font-weight: 500; color: #888;
  text-transform: uppercase; letter-spacing: 0.06em; margin-bottom: 6px;
}
.pm-select { flex: 1; }
.pm-divider { margin: 20px 0; }
.pm-perms-header { margin-bottom: 14px; gap: 10px; }
.pm-section-main-title { font-size: 14px; font-weight: 500; color: #2D4B95; }

/* Seleccionar todo global */
.pm-select-all-global {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 5px 11px;
  border-radius: 20px;
  border: 1px solid #C5D0EA;
  transition: background 0.15s;
  user-select: none;
}
.pm-select-all-global:hover { background: #EEF2FB; }
.pm-select-all-label { font-size: 12px; color: #999; white-space: nowrap; }
.pm-select-all-label--active { color: #2D4B95; font-weight: 500; }

/* Grid de secciones */
.pm-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-bottom: 8px;
}
.pm-section {
  border: 1px solid #E0E6F5;
  border-radius: 10px;
  padding: 10px 14px 12px;
}
.pm-section--full { grid-column: span 2; }

/* Header interno de sección */
.pm-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.pm-section-title {
  font-size: 11px; font-weight: 500; color: #2D4B95;
  text-transform: uppercase; letter-spacing: 0.07em;
  display: flex; align-items: center;
}
.pm-select-all-section {
  font-size: 11px;
  color: #2D4B95;
  cursor: pointer;
  text-decoration: underline;
  text-decoration-color: #C5D0EA;
  text-underline-offset: 2px;
  user-select: none;
  white-space: nowrap;
}
.pm-select-all-section:hover { color: #1C3A7A; text-decoration-color: #1C3A7A; }

/* Checkboxes */
.pm-check { margin-top: 2px !important; }
/deep/ .pm-check .v-label { font-size: 12px !important; color: #444 !important; }
/deep/ .pm-check .v-input--selection-controls__input { margin-right: 4px; }
/deep/ .pm-check.v-input--checkbox .v-icon { font-size: 18px !important; }

/* Grid archivos */
.pm-files-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 12px;
}

/* Footer */
.pm-footer {
  display: flex; justify-content: flex-end; align-items: center;
  gap: 8px; padding: 14px 24px; border-top: 1px solid #F0F0F0;
}
.pm-btn-cancel { color: #2D4B95 !important; border-color: #C5D0EA !important; }

/* Responsive */
@media (max-width: 540px) {
  .pm-grid { grid-template-columns: 1fr; }
  .pm-section--full { grid-column: span 1; }
  .pm-files-grid { grid-template-columns: 1fr 1fr; }
}
</style>